// Não é possível detectar WebView apenas verificando se o User-Agent possui "wv" ou "WebView",
// pois em android 8.1 ou abaixo, o User-Agent possui essas strings em navegadores nativos.
export function isWebView() {
	const regex =
		/(FBAN|FBAV|Instagram|Twitter|LINE|iPhone.*AppleWebKit(?!.*Safari))/i;
	return regex.test(navigator.userAgent || navigator.vendor);
}
